/**
 * @module FE-CU13_戸締り確認画面
 */
import Header from '../../../../components/header/Header.vue';
import BreadCrumbList from '../../../../components/breadCrumb/List.vue';
import LockConfirmation from './components/LockConfirmation.vue';
import MobileFooter from '../../../../components/footer/MobileFooter.vue';
import PcPageTitle from '../../../../components/pcPageTitle/PcPageTitle.vue';
import CONSTANTS from '../../../../constants';

const PAGE_ID = 'FE-CU13';

export default {
  name: 'LockedConfirm',
  components: {
    Header,
    BreadCrumbList,
    LockConfirmation,
    MobileFooter,
    PcPageTitle,
  },
  data(vm) {
    return {
      title: vm.$vuetify.lang.t('$vuetify.FECU13戸締り確認画面.戸締り確認'),
      panelTitle: {
        place: '',
        type: '$vuetify.FECU13戸締り確認画面.対象地区詳細表示領域.対象地区',
        typeIsBefore: true,
      },
      displayAreaList: [
        {
          id: 1,
          title: '$vuetify.FECU13戸締り確認画面.対象地区詳細表示領域.利用プラン',
          text: '',
        },
        {
          id: 2,
          title: '$vuetify.FECU13戸締り確認画面.対象地区詳細表示領域.お客様番号',
          text: '',
        },
        {
          id: 3,
          title: '$vuetify.FECU13戸締り確認画面.対象地区詳細表示領域.警備先名',
          text: '',
        },
        {
          id: 4,
          title: '$vuetify.FECU13戸締り確認画面.対象地区詳細表示領域.地区番号',
          text: '',
        },
        {
          id: 5,
          title: '$vuetify.FECU13戸締り確認画面.対象地区詳細表示領域.地区名',
          text: '',
        },
      ],
      planCode: [
        '$vuetify.コード.利用プランID.オンライン監視プラン',
        '$vuetify.コード.利用プランID.依頼かけつけプラン',
        '$vuetify.コード.利用プランID.依頼かけつけプラン',
        '$vuetify.コード.利用プランID.セルフ監視プラン',
        '$vuetify.コード.利用プランID.セルフ監視プラン',
      ],
      securityAreaList: [],
      CONSTANTS: CONSTANTS,
      //ページの表示タイミング
      isShowPage: false,
    };
  },
  computed: {
    i18nItems(vm) {
      return {
        title: vm.$vuetify.lang.t('$vuetify.FECU13戸締り確認画面.戸締り確認'),
        hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU13戸締り確認画面.C0001'),
      };
    },
  },
  /** @type {Methods} */
  methods: {
    /**
     * 戸締り状態取得(APP_CU1301)
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストのパラメータ
     * @param {*} method リクエストメソッド
     * @returns レスポンス
     */
    APP_CU1301: async function (param, queries, method) {
      this.$_setLoading(true);

      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     displayDistrictInfo: {
            //       usagePlan: 1,
            //       customerNumber: "51-1234567",
            //       securityDestinationName: "警備先1",
            //       districtSplitNumber: "0001",
            //       districtSplitName: "地区名1",
            //       displayDistrictNickname: "自宅",
            //     },
            //     sendCustomerNumber: "sendCustomerNumber",
            //     sendCommandKey: "sendCommandKey",
            //   },
            // };
            this.panelTitle = {
              place: `- ${apiData.contentsInfo.displayDistrictInfo.displayDistrictNickname} `,
              type: '$vuetify.FECU13戸締り確認画面.対象地区詳細表示領域.対象地区',
              typeIsBefore: true,
            };
            this.displayAreaList[0].text =
              this.planCode[apiData.contentsInfo.displayDistrictInfo.usagePlan];
            this.displayAreaList[1].text = apiData.contentsInfo.displayDistrictInfo.customerNumber;
            this.displayAreaList[2].text =
              apiData.contentsInfo.displayDistrictInfo.securityDestinationName;
            this.displayAreaList[3].text =
              apiData.contentsInfo.displayDistrictInfo.districtSplitNumber === '    '
                ? '$vuetify.FECU13戸締り確認画面.対象地区詳細表示領域.メイン地区'
                : apiData.contentsInfo.displayDistrictInfo.districtSplitNumber;
            this.displayAreaList[4].text =
              apiData.contentsInfo.displayDistrictInfo.districtSplitName;
          },
          (error) => {
            this.$_abnormality(error.response.status);
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      return apiData;
    },
    /**
     * 警備ユニットコマンド実行結果確認(APP_CO9915)
     * @param {*} params リクエストのパラメータ
     * @returns レスポンス
     */
    APP_CO9915: async function (params) {
      this.$_setLoading(true);

      let apiData = '';
      await this.$store
        .dispatch(`requestApi/postSecurityUnitExecutionResult`, {
          params: params,
        })
        .then((response /* eslint-disable-line */) => {
          apiData = response;
          // サンプルデータ
          // apiData = {
          //   contentsInfo: {
          //     securityUnitExecutionResult: 0,
          //     commandExecutionResult: {
          //       app_cu1301: {
          //         securityAreaInfo: [
          //           {
          //             securityAreaId: "1",
          //             securityAreaName: "玄関",
          //             lockUpStatus: false,
          //           },
          //           {
          //             securityAreaId: "2",
          //             securityAreaName: "キッチン",
          //             lockUpStatus: true,
          //           },
          //           {
          //             securityAreaId: "3",
          //             securityAreaName: "リビング",
          //             lockUpStatus: false,
          //           },
          //           {
          //             securityAreaId: "4",
          //             securityAreaName: "寝室",
          //             lockUpStatus: true,
          //           },
          //           {
          //             securityAreaId: "5",
          //             securityAreaName: "ベランダ",
          //             lockUpStatus: false,
          //           },
          //           {
          //             securityAreaId: "6",
          //             securityAreaName: "2階子供",
          //             lockUpStatus: false,
          //           },
          //         ],
          //         warningOccurredFlg: false,
          //       },
          //     },
          //   },
          // };

          if (apiData.contentsInfo.securityUnitExecutionResult == 0) {
            let securityAreaList = [];
            apiData.contentsInfo.commandExecutionResult.app_cu1301.securityAreaInfo.forEach(
              function (securityArea) {
                securityAreaList.push({
                  id: securityArea.securityAreaId === 'A' ? '10' : securityArea.securityAreaId,
                  securityAreaName: securityArea.securityAreaName,
                  isSFRStatus: securityArea.lockUpStatus,
                  getStatus: true,
                });
              }
            );
            securityAreaList.sort((a, b) => a.id - b.id);
            this.securityAreaList = securityAreaList;
          } else {
            this.$_securityUnitExecutionResultDialog(
              apiData.contentsInfo.securityUnitExecutionResult
            );
          }
        })
        .finally(() => {
          // ブラウザバック時に遷移先で Loading が途切れるのを回避
          if (this.$route.name === this.$options.name) {
            this.$_setLoading(false);
          }
        });

      return apiData;
    },
  },

  async mounted() {
    window.scroll({ top: 0, behavior: 'smooth' });
    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    this.$_pvCount(PAGE_ID);

    if (this.$store.getters['isLoggedIn']) {
      await this.$refs.header.APP_CU0201();
    }

    //以降は、ローディングマークを出して警備ユニットとの通信なので、ここで画面表示
    this.isShowPage = true;

    // reset
    this.$store.commit('setGettingInFlag', { gettingInFlag: false });

    let param = '/api/lockConfirmation/init';
    // let param = "post";

    let queries = {
      token: sessionStorage.getItem('token'),
      terminalInfo: localStorage.getItem('terminalInfo')
        ? localStorage.getItem('terminalInfo')
        : '',
      customerNumber: this.$store.state.customerNumber,
      districtSplitNumber: this.$store.state.districtSplitNumber,
    };

    let method = 'post';
    // APP_CU1301
    let apiData = await this.APP_CU1301(param, queries, method);

    if (typeof apiData.contentsInfo !== 'undefined') {
      let params = {
        token: queries.token,
        terminalInfo: queries.terminalInfo,
        sendCustomerNumber: apiData.contentsInfo.sendCustomerNumber,
        sendCommandKey: apiData.contentsInfo.sendCommandKey,
        apiId: 6,
        alarmType: 0,
        districtSplitNumber: '',
        securityAreaId: '',
      };
      await this.APP_CO9915(params);
    }
  },
};
